module.exports = __webpack_public_path__ + "img/cass8.e1101261.jpg";